import {
  CategoryType,
  ExerciseBase,
  ExerciseType,
} from "./exercises.types";

export const mockComprendreExercises: ExerciseBase[] = [
  {
    id: "compr-micro-1",
    title: "Comprendre le biais de confirmation",
    description: "Identifier comment notre cerveau privilégie les infos qui confirment ce qu’on pense déjà.",
    category: CategoryType.COMPRENDRE,
    type: ExerciseType.MICRO_COURS,
    estimatedDuration: 5,
    level: "intermédiaire",
  },
  {
    id: "compr-quiz-1",
    title: "Quiz rapide : info ou opinion ?",
    description: "Repérer si une affirmation est un fait vérifiable ou une interprétation.",
    category: CategoryType.COMPRENDRE,
    type: ExerciseType.QUIZ,
    estimatedDuration: 4,
    level: "débutant",
  },
  {
    id: "compr-analyse-1",
    title: "Analyse rapide d’un article viral",
    description: "Découper un article en faits, hypothèses et angles de narration.",
    category: CategoryType.COMPRENDRE,
    type: ExerciseType.ANALYSE_RAPIDE,
    estimatedDuration: 7,
    level: "intermédiaire",
  },
  {
    id: "compr-micro-2",
    title: "Micro-cours : sources fiables",
    description: "Apprendre à remonter à la source d’une info en quelques étapes simples.",
    category: CategoryType.COMPRENDRE,
    type: ExerciseType.MICRO_COURS,
    estimatedDuration: 6,
    level: "débutant",
  },
];

export const mockPratiquerExercises: ExerciseBase[] = [
  {
    id: "prat-cog-1",
    title: "Cherche & vérifie",
    description: "Formuler une question, obtenir une réponse d’IA, puis vérifier et nuancer.",
    category: CategoryType.PRATIQUER,
    type: ExerciseType.COGNITIF,
    estimatedDuration: 8,
    level: "intermédiaire",
  },
  {
    id: "prat-defis-1",
    title: "Défis réels : convaincre un proche",
    description: "Construire un argumentaire équilibré pour un sujet sensible.",
    category: CategoryType.PRATIQUER,
    type: ExerciseType.DEFIS_REELS,
    estimatedDuration: 10,
    level: "avancé",
  },
  {
    id: "prat-simu-1",
    title: "Simulation : interview express",
    description: "Simuler une mini-interview pour tester tes questions ouvertes vs fermées.",
    category: CategoryType.PRATIQUER,
    type: ExerciseType.SIMULATION,
    estimatedDuration: 6,
    level: "débutant",
  },
  {
    id: "prat-cog-2",
    title: "Détecter les biais dans une réponse IA",
    description: "Passer en revue une réponse et repérer formulations orientées ou incomplètes.",
    category: CategoryType.PRATIQUER,
    type: ExerciseType.COGNITIF,
    estimatedDuration: 7,
    level: "intermédiaire",
  },
];

export const mockExplorerExercises: ExerciseBase[] = [
  {
    id: "expl-ill-1",
    title: "Illusion de choix",
    description: "Comparer deux versions d’une histoire pour voir comment le contexte influence ton jugement.",
    category: CategoryType.EXPLORER,
    type: ExerciseType.ILLUSION,
    estimatedDuration: 5,
    level: "débutant",
  },
  {
    id: "expl-hist-1",
    title: "Histoire interactive : enquête rapide",
    description: "Suivre une courte enquête et choisir quels indices explorer en priorité.",
    category: CategoryType.EXPLORER,
    type: ExerciseType.HISTOIRE,
    estimatedDuration: 9,
    level: "intermédiaire",
  },
  {
    id: "expl-crea-1",
    title: "Créativité guidée",
    description: "Imaginer trois suites possibles à une scène, puis demander à l’IA de t’inspirer différemment.",
    category: CategoryType.EXPLORER,
    type: ExerciseType.CREATIVITE,
    estimatedDuration: 7,
    level: "débutant",
  },
  {
    id: "expl-ill-2",
    title: "Illusion d’autorité",
    description: "Comparer deux réponses similaires, l’une signée « expert », l’autre anonyme, et observer ton ressenti.",
    category: CategoryType.EXPLORER,
    type: ExerciseType.ILLUSION,
    estimatedDuration: 6,
    level: "intermédiaire",
  },
];
